import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "../../modules/user/stores";
import { ROUTES } from "../../types/routes";
import { openLoginRegisterPopup } from "../LoginRegisterPopup";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * 未登录时弹出底部登录注册弹窗，同时重定向到首页。
 * 登录成功后弹窗内会自动跳转回原目标路由。
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useUserStore(state => state.isAuthenticated());

  useEffect(() => {
    if (!isAuthenticated) {
      openLoginRegisterPopup({ from: location.pathname });
    }
  }, [isAuthenticated, location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.HOME} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
